/**
 * Amplify Configuration
 *
 * This configuration is loaded at runtime from environment variables.
 * In production, these are set by Amplify automatically.
 */

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    REST: {
      kindafearless: {
        endpoint: import.meta.env.VITE_API_URL || '/api',
      },
    },
  },
};

export default amplifyConfig;
